import { reportTypeLabels } from '@features/campaign-list/domain/report';
import { campaignTypeLabels } from '@features/campaign-list/domain/campaign';
import { FilterContext } from '@features/campaign-list/stores/filter-context';
import { Chip } from '@mui/material';
import { useContext } from 'react';

export const SelectionChips = () => {
  const { filterState, dispatch } = useContext(FilterContext);

  const totalFilters =
    (filterState.selectedClient ? 1 : 0) +
    filterState.checkedAdvertisers.length;

  return (
    <>
      {totalFilters > 0 ? (
        <Chip color="primary" label={totalFilters} size="small" />
      ) : null}
      <Chip
        variant="outlined"
        label={campaignTypeLabels[filterState.selectedCampaignType]}
      />
      <Chip
        variant="outlined"
        label={reportTypeLabels[filterState.selectedReportType]}
      />
      {[filterState.selectedClient].map(
        client =>
          client && (
            <Chip
              key={client.id}
              variant="outlined"
              label={client.name}
              onDelete={() =>
                dispatch({ type: 'client_selected', payload: null })
              }
            />
          )
      )}
      {filterState.checkedAdvertisers.map(advertiser => (
        <Chip
          key={advertiser.id}
          variant="outlined"
          label={advertiser.name}
          onDelete={() =>
            dispatch({ type: 'advertiser_toggled', payload: advertiser })
          }
        />
      ))}
    </>
  );
};
